/**
 * Default configuration values.
 * Vector tile URL points to Pilot's self-hosted tileserver-gl.
 * All map rendering is HIPAA-compliant — no third-party tile requests.
 */
export const DEFAULTS = {
  height: '450px',
  style: 'high-contrast',
  minZoom: 3,
  maxZoom: 18,
  brandColor: '#2563eb',
  directions: 'google',
  popupFields: ['address', 'phone', 'hours'],

  // Self-hosted vector tile server
  tileServer: 'https://maps.sounderdata.com/tiles',

  // Tile attribution (required by OSM/ODbL license)
  attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',

  // Sidebar search debounce (ms)
  searchDebounce: 200,

  // Google Sheets CSV proxy pattern
  sheetCsvUrl: (id) =>
    `https://docs.google.com/spreadsheets/d/${id}/gviz/tq?tqx=out:csv`,
};

/**
 * Directions URL builders per provider.
 */
export const DIRECTIONS = {
  google: (address) =>
    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`,
  apple: (address) =>
    `https://maps.apple.com/?daddr=${encodeURIComponent(address)}`,
  geo: (lat, lng) =>
    `geo:${lat},${lng}`,
};
